import { Link } from "@tanstack/react-router";
import { useMutation } from "@tanstack/react-query";
import type { ReactNode } from "react";
import { apiAuth, setCsrfToken } from "../api.js";

const LINKS = [
  { to: "/", label: "Dashboard" },
  { to: "/projects", label: "Projects" },
  { to: "/kocs", label: "KOCs" },
  { to: "/videos", label: "Videos" },
  { to: "/jobs", label: "Jobs" },
] as const;

export function Layout({ children }: { children: ReactNode }) {
  const logout = useMutation({
    mutationFn: () => apiAuth.logout(),
    onSuccess: () => { setCsrfToken(null); window.location.reload(); },
  });

  return (
    <div className="flex h-screen overflow-hidden">
      <aside className="w-56 shrink-0 bg-stone-900 text-stone-100 flex flex-col">
        <div className="p-4 text-lg font-semibold border-b border-stone-700">
          KOC Platform
        </div>
        <nav className="flex-1 p-2 space-y-1">
          {LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="block px-3 py-2 rounded text-sm hover:bg-stone-800"
              activeProps={{ className: "block px-3 py-2 rounded text-sm bg-stone-800 font-medium" }}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <button
          type="button"
          onClick={() => logout.mutate()}
          className="m-2 text-xs text-stone-400 hover:text-stone-100 px-3 py-2 rounded hover:bg-stone-800 text-left"
        >
          Logout
        </button>
      </aside>
      <main className="flex-1 overflow-auto p-6">{children}</main>
    </div>
  );
}
